import { render, staticRenderFns } from "./noMiniprogram.vue?vue&type=template&id=6afbd338&scoped=true"
import script from "./noMiniprogram.vue?vue&type=script&lang=js"
export * from "./noMiniprogram.vue?vue&type=script&lang=js"
import style0 from "./noMiniprogram.vue?vue&type=style&index=0&id=6afbd338&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afbd338",
  null
  
)

export default component.exports